/* Colour lookup for the "Make it a set" rows.
   Caps and accessories come from products.json, which carries no swatch
   metafield, so the colour is read from the product name and mapped to the
   same palette the filters use. Falls back to the frame's own colour. */
(function(){
"use strict";
var MAP=[
 ['tortoise','#8a5a2b'],['tiffany','#9bd1cc'],['gunmetal','#8b8f92'],['graphite','#8b8f92'],
 ['charcoal','#4a4f52'],['burgundy','#7a2f38'],['maroon','#7a2f38'],['bronze','#8c6a3f'],
 ['champagne','#c9b487'],['lavender','#9b8fc7'],['turquoise','#5bb5ad'],['camel','#b98f5e'],
 ['khaki','#9c9270'],['olive','#6b7a4a'],['beige','#d8c9a8'],['ivory','#efe9dc'],
 ['cream','#f0e8d8'],['nude','#d9b9a3'],['peach','#e8b48c'],['coral','#e08a6a'],
 ['navy','#2f4763'],['denim','#5878a0'],['sky','#9dc4e6'],['teal','#3f8f8a'],
 ['mint','#a9ddc6'],['sage','#9aab8b'],['lime','#c3d94e'],['forest','#3f5c46'],
 ['rose','#e0a3ae'],['blush','#f0c4c9'],['lilac','#b9a7d6'],['violet','#7d6b9c'],
 ['purple','#7d6b9c'],['amber','#d9a441'],['mustard','#d2b13c'],['sand','#dbc9a3'],
 ['stone','#c2bcb2'],['slate','#6c7a84'],['silver','#c9ccce'],['gold','#b39a63'],
 ['black','#1c1c1c'],['white','#e9e9e6'],['grey','#8b8f92'],['gray','#8b8f92'],
 ['brown','#6b4a30'],['blue','#3a5a7d'],['green','#4c6b4f'],['red','#9c3b32'],
 ['pink','#e59ab4'],['yellow','#e3c74a'],['orange','#c86b2d'],['clear','#dfe3e4'],
 ['crystal','#dfe3e4'],['gun','#8b8f92'],['camo','#6b7a4a'],['wash','#b7bcc0']
];
window.SFTint=function(name, fallback){
  var t=String(name||'').toLowerCase();
  for(var i=0;i<MAP.length;i++){ if(t.indexOf(MAP[i][0])>-1) return MAP[i][1] }
  return fallback||'#9bd1cc';
};
})();